<ngx-bootstrap-multiselect
    [settings]="settings"
    [texts]="texts"
    [options]="options"
    [(ngModel)]="configuracoes"
    (ngModelChange)="onChange()"
    [disabled]="disabled">
</ngx-bootstrap-multiselect>